import type { JobRecommendationFragment, Maybe } from '@/graphql/generated';
import type { JobRecommendationFragmentWithVisibleJob } from '@/types';

type RecommendationNode = {
  node: JobRecommendationFragment;
};

const isVisibleJob = (item: Maybe<JobRecommendationFragment>): item is JobRecommendationFragmentWithVisibleJob => {
  return item?.job?.__typename === 'VisibleJob';
};

const mapRecommendations = (item: RecommendationNode): JobRecommendationFragment => {
  return item.node;
};

export const getFilteredRecommendations = (items: RecommendationNode[]): JobRecommendationFragmentWithVisibleJob[] =>
  items.map(mapRecommendations).filter(isVisibleJob);
